module.exports = __webpack_public_path__ + "static/img/round3.cef07f27.jpg";